<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:00:48
 * @Description: 评估仪器管理
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="设备名称"
              prop="sbmc"
            >
              <el-input
                v-model="fd.sbmc"
                class="c-form__input"
                autocomplete="off"
                maxlength="100"
                placeholder="请输入设备名称"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="设备编号"
              prop="sbbh"
            >
              <el-input
                v-model="fd.sbbh"
                class="c-form__input"
                autocomplete="off"
                maxlength="100"
                placeholder="请输入设备编号"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="检定/校准证件编号"
              prop="jyzjbh"
            >
              <el-input
                v-model="fd.jyzjbh"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入检定/校准证件编号！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="有效期"
              prop="htje"
            >
              <el-date-picker
                v-model="fd.yxq"
                value-format="timestamp"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="是否启用"
              prop="sfqy"
            >
              <el-radio-group v-model="fd.sfqy">
                <el-radio label="Y">
                  启用
                </el-radio>
                <el-radio label="N">
                  停用
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgyqManageService } from './pgyq.service.js';
export default {
  name: 'AddDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      id: null,
      /* 表单参数 Start */
      fd: {
        sbmc: null, // 设备名称
        sbbh: null, // 设备编号
        jyzjbh: null,
        yxq: null,
        sfqy: null
      },
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        sbmc: [this.$validUtils.required('设备名称')],
        sbbh: [this.$validUtils.required('设备编号')],
        sfqy: [this.$validUtils.required('是否启用')]
      },
      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改
      /* 表单校验规则 End */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改信息' : '添加信息'}`;
    }

  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      pgyqManageService.getDetail(this.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取评估仪器信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      this.loading = true;
      pgyqManageService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      this.loading = true;
      pgyqManageService.update(this.id, this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    }

  },
  created () {
    if (this.dlParams.id) {
      this.dlType = this.dlParams.type;
      this.id = this.dlParams.id;
      this.init();
    }
  }
};

</script>
